import React, { useCallback, useEffect, useRef, useState } from "react";
import { DispatchTransactionEvent } from "../events/events";
import {
  ShowError, confirmationDialog, 
  JSON_KEY_MESSAGE_TYPE, EVENT_TOPIC_FOR_TRANSACTION_SERVER, 
  JSON_KEY_SUBMITTER, 
  ITEM_CREATE, ITEM_MODIFY, JSON_KEY_INDEX,
  ITEM_DELETE,
  EVENT_TYPE_INDEX_MEMBER_MODIFY,
  EVENT_TYPE_INDEX_MEMBER_CREATE,
  EVENT_TYPE_INDEX_MEMBER_DEFUNCT,
  JSON_KEY_INSTRUMENT,
  JSON_KEY_FACTOR,
  StatusOptions,
  JSON_KEY_STATUS,
  ConvertStatusFromNameToId,
  STATUS_SUSPEND,
  ConvertStatus,
  JSON_KEY_PRICE,
} from "../../common/common";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "../tabs/tabs.css";
import { Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { selectTableData, selectTSUserId } from "../../redux/globalsSlice";
import { MSG_TYPE_INDEX_MEMBERS_CREATE, MSG_TYPE_INDEX_MEMBERS_STATUS, MSG_TYPE_INDEX_MEMBERS_MODIFY, } from "../../common/msg_types";
import { RenderDropdown, InputField } from "../../common/utilies";
import { FACTOR_DECIMALS } from "../tables/index_members";

const IndexMembersAdminForm = ({ rowData, onClose, indicesOptions, instrumentCodeOptions }) => {
   const userId = useSelector(selectTSUserId);
   const [selectedTabIndex, setSelectedTabIndex] = useState(0);
   const [lastPriceEnabled, setLastPriceEnabled] = useState(false);
   
   // acces to instruments table data for price decimals
   const instrumentsTableData = useSelector(selectTableData); // ✅ get full table data from redux
   const instrumentsTableDataRef = useRef({});
   useEffect(() => {
      instrumentsTableDataRef.current = instrumentsTableData;
   }, [instrumentsTableData]);
   

   // Form handling
   const {
      handleSubmit,
   } = useForm({});

   // tab1
   const [code, setCode] = useState(rowData?.idx || '');
   const [instrumentCode, setInstrumentCode] = useState(rowData?.instr || '');
   const [status, setStatus] = useState(ConvertStatusFromNameToId(rowData?.status ?? STATUS_SUSPEND));
   
   // tab 2 & 3
   const [factor, setFactor] = useState(rowData?.factor);
   const [last_price, setLastPrice] = useState("");
   const handleCancel = () => {
      if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
      }
      onClose(); // your modal close function
   };

   const onIndexDropDownChange = useCallback((e) => setCode(e.target.value), [setCode]);
   const onInstrumentCodeDropDownChange = useCallback((e) => setInstrumentCode(e.target.value), [setInstrumentCode]);
   // const onStatusDropDownChange = useCallback((e) => {
   //    conslog('status: ', status);
   //    setStatus(e.target.value), [setStatus]);
   // }
   const onStatusDropDownChange = useCallback((e) => {
      setStatus(e.target.value);         // update status
      console.log("onStatusDropDownChange status: ", status, ", convert: ");   // log the current status
   }, [status, setStatus]);

   const ConfirmAndSubmit = async ({ title, text, item }) => {
      const confirmed = await confirmationDialog({ title, text });
      if (confirmed) handleStatusConfirmationSubmit(item);
   };

   const handleStatusConfirmationSubmit = (submitItem) => {
      const instrumentRow = instrumentsTableDataRef.current[instrumentCode];
      if (!instrumentRow) return;

      const decimals = instrumentRow.price_dec;
      console.log('dec: ', decimals, ', price: ', last_price, ', inst: ', instrumentRow, ', instdec: ', instrumentRow.price_decimals);

      const base = {
         [JSON_KEY_SUBMITTER]: userId,
         [JSON_KEY_INDEX]: code,
         [JSON_KEY_INSTRUMENT]: instrumentCode,
      };

      switch (submitItem) {
         case ITEM_DELETE:
            DispatchTransactionEvent(
               EVENT_TOPIC_FOR_TRANSACTION_SERVER,
               EVENT_TYPE_INDEX_MEMBER_DEFUNCT,
               {
                  ...base,
                  [JSON_KEY_MESSAGE_TYPE]: MSG_TYPE_INDEX_MEMBERS_STATUS,
                  [JSON_KEY_STATUS]: status,
                  
               }
            );
            break;

         case ITEM_CREATE:
            const payload1 = {
               ...base,
               [JSON_KEY_MESSAGE_TYPE]: MSG_TYPE_INDEX_MEMBERS_CREATE,
               [JSON_KEY_FACTOR]: Math.round(parseFloat(factor) * Math.pow(10, FACTOR_DECIMALS)),
            };

            if (last_price || last_price === 0) {
               payload1[JSON_KEY_PRICE] = Math.round(parseFloat(last_price) * Math.pow(10, decimals));
            }

            DispatchTransactionEvent(
               EVENT_TOPIC_FOR_TRANSACTION_SERVER,
               EVENT_TYPE_INDEX_MEMBER_CREATE,
               payload1,
            );

            break;

         case ITEM_MODIFY:
            const payload = {
               ...base,
               [JSON_KEY_MESSAGE_TYPE]: MSG_TYPE_INDEX_MEMBERS_MODIFY,
               [JSON_KEY_FACTOR]: Math.round(parseFloat(factor) * Math.pow(10, FACTOR_DECIMALS)),
               [JSON_KEY_STATUS]: status,
            };

            if (last_price || last_price === 0) {
               payload[JSON_KEY_PRICE] = Math.round(parseFloat(last_price) * Math.pow(10, decimals));
            }

            DispatchTransactionEvent(
               EVENT_TOPIC_FOR_TRANSACTION_SERVER,
               EVENT_TYPE_INDEX_MEMBER_MODIFY,
               payload,
            );
            break;

         default:
            console.log("IndexMembersAdminForm unknown submit item");
      }
   };


   const ValidateFields = () => {
      if (!code) return "Code is missing";
      if (!instrumentCode) return "Instrument code is missing";
      if (!status) return "Status is missing";
      return null;
   };

   const handleCreateSubmit = () => {
      const error = ValidateFields();
      if (error) return ShowError(error);

      ConfirmAndSubmit({
         title: "Create Member",
         text: `Creating new member: ${instrumentCode} for Index ${code}`,
         item: ITEM_CREATE,
      });
      onClose(); // your modal close function
   };

   const handleModifySubmit = () => {
      const error = ValidateFields();
      if (error) return ShowError(error);

      ConfirmAndSubmit({
         title: "Modify Member",
         text: `Modifying member: ${instrumentCode}`,
         item: ITEM_MODIFY,
      });
      onClose(); // your modal close function
   };

   const handleDeleteSubmit = () => {
      const error = ValidateFields();
      if (error) return ShowError(error);

      ConfirmAndSubmit({
         title: "Delete Member",
         text: `Changing status to ${ConvertStatus(status)} for Member: ${instrumentCode} from Index ${code}`,
         item: ITEM_DELETE,
      });
      
      onClose(); // your modal close function
   };

   useEffect(() => {
      if (!rowData) return;
         setCode(rowData.idx || '');
   }, [rowData]);

   return (
      <div className="admin-form">
         <div className="admin-tabs">
         <h2 className="center-heading">Index Members Administration</h2>
         <Tabs selectedIndex={selectedTabIndex} onSelect={setSelectedTabIndex} forceRenderTabPanel={true} className="admin-tabs" >
            <TabList>
               <Tab>Status Member</Tab>
               <Tab>Modify Member</Tab>
               <Tab>Create Member</Tab>
            </TabList>

            {/* Tab 1: Delete Index Member */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleDeleteSubmit)}>
               <div className="top">
                  {RenderDropdown("Index", code, indicesOptions, onIndexDropDownChange)}
               </div>

               <div className="top">
                  {RenderDropdown("Instrument", instrumentCode, instrumentCodeOptions, onInstrumentCodeDropDownChange)}
               </div>

               <div className="top">
                  {RenderDropdown("Status", status, StatusOptions, onStatusDropDownChange)}
               </div>
               
               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>            

            {/* Tab 2: Modify Index Member */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleModifySubmit)}>
               <div className="top">
                  {RenderDropdown("Index", code, indicesOptions, onIndexDropDownChange)}
               </div>

               <div className="top">
                  {RenderDropdown("Instrument", instrumentCode, instrumentCodeOptions, onInstrumentCodeDropDownChange)}
               </div>

               <div>
                  <InputField label="Factor" value={factor} onChange={setFactor} type="number" />
               </div>

               {/* Toggle to enable/disable Last Price */}
               <div className="form-group">
                  <label className="form-label">
                     <input
                        type="checkbox"
                        checked={lastPriceEnabled}
                        onChange={(e) => {
                        setLastPriceEnabled(e.target.checked);
                        if (!e.target.checked) setLastPrice(""); // clear when disabling
                        }}
                     />
                     {" "} Set Last Price
                  </label>
               </div>
               
               <div>
                  <InputField label="Last Price" value={last_price} onChange={setLastPrice} type="number" readOnly={!lastPriceEnabled} />
               </div>

               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>            
             
            {/* Tab 3: Create Member */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleCreateSubmit)}>
               <div className="top">
                  {RenderDropdown("Index", code, indicesOptions, onIndexDropDownChange)}
               </div>

               <div className="top">
                  {RenderDropdown("Instrument", instrumentCode, instrumentCodeOptions, onInstrumentCodeDropDownChange)}
               </div>

               <div>
                  <InputField label="Factor" value={factor} onChange={setFactor} type="number" />
               </div>

               {/* Toggle to enable/disable Last Price */}
               <div className="form-group">
                  <label className="form-label">
                     <input
                        type="checkbox"
                        checked={lastPriceEnabled}
                        onChange={(e) => {
                        setLastPriceEnabled(e.target.checked);
                        if (!e.target.checked) setLastPrice(""); // clear when disabling
                        }}
                     />
                     {" "} Set Last Price
                  </label>
               </div>

               <div>
                  <InputField label="Last Price" value={last_price} onChange={setLastPrice} type="number" readOnly={!lastPriceEnabled} />
               </div>

               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>
         </Tabs>
         </div>
      </div>
   );
};

export default IndexMembersAdminForm;
